/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var BreadcrumbView = require('common/views/BreadcrumbView');

var tmplCOCContactDashboardView = require('../templates/COCContactDashboardView.hbs');
var COCContactFormView = require('./COCContactFormView');
var DropdownView = require('common/views/DropdownView');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCContactDashboardView,

  className: 'coc-contact-dashboard-view container-fluid',

  ui: {
    breadCrumbContainer: '.breadcrumb-container',
    contactFormContainer: '.contact-form-container',
    contactActionDropdown: '.contact-action-drop-down'
  },

  regions: {
    breadCrumbContainer: '@ui.breadCrumbContainer',
    contactFormContainer: '@ui.contactFormContainer',
    contactActionDropdown: '@ui.contactActionDropdown'
  },

  templateHelpers: function() {},

  onBeforeShow: function() {
    var contact = this.model.get('contact');
    this.showChildView(
      'breadCrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#coc/dashboard'
          },
          {
            text: contact.firstName + ' ' + contact.lastName
          }
        ]
      })
    );

    this.showChildView(
      'contactActionDropdown',
      new DropdownView({
        rightAlign: true,
        model: new Backbone.Model({
          name: 'Contact Actions',
          options: [
            {
              text: 'Edit Contact',
              link: '#coc/contact/' + contact.contactId + '/edit'
            }
          ]
        })
      })
    );
    this.contactForm = new COCContactFormView({ model: this.model, isReadOnly: true });
    this.showChildView('contactFormContainer', this.contactForm);
  }
});
